module.exports = __webpack_public_path__ + "img/pichler.b068747a.svg";